<template lang="html">
  <div>
    <div class="vx-card nexteventheader_div">
      <div class="vx-card__header">
      <div class="vx-card__title">
      <p class=""><h6>Edit Configurations</h6></p>
    </div>
    <vs-button style="float:right;" @click="redirect()">Back</vs-button>
    </div>
      <div style="padding: 15px;">
          <div v-if="is_sms_enabled == 1 || is_email_enabled == 1" style="margin-bottom: 15px;">
            <label>Title:</label>
            <vs-input v-model="title" class="w-full" disabled />
          </div>
          <div v-if="is_email_enabled == 1">
            <div style="margin-bottom: 15px;">
              <label>Subject:</label>
              <vs-input v-model="email_subject" class="w-full"/>
            </div>
            <div style="margin-bottom: 15px;">
              <label>Email Body:</label>
              <ckeditor v-model="email_body"></ckeditor>
            </div>
          </div>
          <div v-if="is_sms_enabled == 1">
            <div style="margin-bottom: 0px;">
              <label>SMS Body:</label>
              <vs-textarea v-model="sms_body" rows="10" style="width:100%; height: auto;" />
            </div>
          </div>
          </div>
          <div v-if="is_sms_enabled == 1 || is_email_enabled == 1">
            <vs-button @click="updateConfig" style="margin-left: 15px;margin-bottom:10px;">Save</vs-button>
          </div>
          <div v-else style="padding: 25px;">
            <p>Please select SMS or EMAIL configuration to edit a template</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { Validator } from "vee-validate";

export default {
  data() {
    return {
      event_id: "",
      slug: "",
      title: "",
      config_id: "",
      email_body: "",
      email_subject: "",
      sms_body: "",
      is_email_enabled: "",
      is_sms_enabled: ""
    };
  },
  mounted() {
    this.getTemplateData();
  },
  created() {
    this.event_id = this.$route.params.id;
    this.slug = this.$route.params.slug;
    this.from = this.$route.params.from;
  },
  methods: {
    updateConfig(){
      let data = {
        "id": this.config_id,
        "event_id": this.event_id,
        "slug": this.slug,
        "body": this.email_body,
        "body_sms": this.sms_body,
        "subject": this.email_subject
      }
      this.$store
      .dispatch("UpdateEventNotifications",data)
      .then(response => {
          this.$vs.loading.close();
          this.$vs.notify({
              title: "Success",
              text: "Cofiguration updated successfully ",
              color: "success",
              position: "top-center"
          });
          this.redirect();
      })
      .catch(error => {
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
              title: "Failed to load data",
              text: error,
              color: "danger",
              position: "top-center"
          });
          return false;
      });
    },
    getTemplateData(){
      this.$vs.loading();
      let data = {"event_id": this.event_id, "slug": this.slug};
      this.$store
      .dispatch("GetEventNotifications",data)
      .then(response => {
          let configData = response.data.data[0];
          this.config_id = configData.id;
          this.title = configData.title;
          this.email_body = configData.body;
          this.email_subject = configData.subject;
          this.sms_body = configData.body_sms;
          this.is_email_enabled = configData.is_enabled;
          this.is_sms_enabled = configData.is_sms_enabled;
          this.$vs.loading.close();
      })
      .catch(error => {
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
              title: "Failed to load data",
              text: error,
              color: "danger",
              position: "top-center"
          });
          return false;
      });
    },
    redirect() {
      if(this.from == 'manage') {
         this.$router.push({ path: '/admin/event/customnotifications/' + this.event_id })
      } else {
          this.$router.push({ path: '/admin/event/notifications/' + this.event_id })
      }
    }
  }
};
</script>